
export const matchWildcard = (s:string, r:string) => {
	return new RegExp("^" + r.split("*").map(escapeRegex).join(".*") + "$").test(s);
};

const escapeRegex = (s:string) => s.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");